const swiper = new Swiper(".swiper-fv", {
    loop: true,
    speed: 800,
    slidesPerView: 1,
    allowTouchMove: true,
    autoplay: {
        delay: 3e3,
        disableOnInteraction: false
    },
    pagination: {
        el: ".swiper-pagination",
        type: "bullets",
        clickable: true
    }
});

const swiperMedia = new Swiper(".swiper-media", {
  loop: true,
  slidesPerView: 2,
  allowTouchMove: true,
  spaceBetween: 20,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    751: {
      slidesPerView: 5,
    },
    376: {
      slidesPerView: 3,
    },
  },
});

!(function () {
  const css = document.createElement("link");
  css.href = "https://cdn.jsdelivr.net/npm/swiper@8/swiper-bundle.min.css";
  css.rel = "stylesheet";
  css.type = "text/css";
  document.head.appendChild(css);
  const script = document.createElement("script");
  script.src = "https://cdn.jsdelivr.net/npm/swiper@8/swiper-bundle.min.js";
  script.setAttribute("charset", "UTF-8");
  document.head.appendChild(script);
  script.onload = function () {
    const swiper = new Swiper(".swiper", option);
  };
})();
